import PhotoPlaceholder from '../components/photo-placeholder';
import { NUESTRA_HISTORIA, VALORES } from '../data/content';
import { eyebrow } from '../lib/styles';

const About = () => (
  <div>
    <section style={{ padding: '5vw', maxWidth: 1000, margin: '0 auto' }}>
      <span style={eyebrow}>Nosotros</span>
      <h1
        style={{
          fontFamily: 'var(--font-display)',
          fontWeight: 300,
          fontSize: 'clamp(34px, 5.6vw, 60px)',
          lineHeight: 1.08,
          color: 'var(--ink-900)',
          margin: '14px 0 22px',
          maxWidth: '16ch',
        }}
      >
        Zenya nació de una idea simple
      </h1>
      <p
        style={{
          fontSize: 'clamp(17px, 2vw, 21px)',
          lineHeight: 1.75,
          color: 'var(--ink-700)',
          margin: 0,
          maxWidth: '58ch',
        }}
      >
        Que arreglarte las uñas o darte un masaje no debería sentirse como un trámite. Debería sentirse como un rato
        tuyo.
      </p>
    </section>

    <section
      className="z-split-grid"
      style={{
        padding: '0 5vw 5vw',
        maxWidth: 1000,
        margin: '0 auto',
        display: 'grid',
        gridTemplateColumns: '1fr',
        gap: '4vw',
        alignItems: 'start',
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '3vw' }}>
        {NUESTRA_HISTORIA.map((h) => (
          <div key={h.titulo}>
            <h2
              style={{
                fontFamily: 'var(--font-display)',
                fontWeight: 400,
                fontSize: 30,
                color: 'var(--ink-900)',
                margin: '0 0 12px',
              }}
            >
              {h.titulo}
            </h2>
            <p style={{ fontSize: 15.5, lineHeight: 1.8, color: 'var(--ink-600)', margin: 0 }}>{h.texto}</p>
          </div>
        ))}
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 14, position: 'sticky', top: 92 }}>
        <PhotoPlaceholder label="Fundadora / equipo Zenya" ratio="3/4" />
        <PhotoPlaceholder label="Detalle del espacio" ratio="4/3" tone="lavender" />
      </div>
    </section>

    <section style={{ background: '#FFF', borderTop: '1px solid var(--ink-100)', padding: '5vw' }}>
      <div style={{ maxWidth: 1100, margin: '0 auto' }}>
        <h2
          style={{
            fontFamily: 'var(--font-display)',
            fontWeight: 300,
            fontSize: 'clamp(28px, 4vw, 42px)',
            color: 'var(--ink-900)',
            margin: '0 0 3vw',
          }}
        >
          Valores
        </h2>
        <div
          style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 220px), 1fr))', gap: 20 }}
        >
          {VALORES.map((v) => (
            <div key={v.titulo} style={{ borderTop: '1px solid var(--rose-300)', paddingTop: 18 }}>
              <h3
                style={{
                  fontFamily: 'var(--font-display)',
                  fontWeight: 400,
                  fontSize: 24,
                  color: 'var(--ink-900)',
                  margin: '0 0 10px',
                }}
              >
                {v.titulo}
              </h3>
              <p style={{ fontSize: 14.5, lineHeight: 1.7, color: 'var(--ink-600)', margin: 0 }}>{v.texto}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section
      style={{
        padding: '5vw',
        maxWidth: 1100,
        margin: '0 auto',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 280px), 1fr))',
        gap: 24,
      }}
    >
      <div style={{ background: 'var(--rose-50)', borderRadius: 'var(--radius-xl)', padding: 32 }}>
        <span style={eyebrow}>Misión</span>
        <p
          style={{
            fontFamily: 'var(--font-display)',
            fontSize: 24,
            lineHeight: 1.45,
            color: 'var(--ink-900)',
            margin: '14px 0 0',
          }}
        >
          Que cada clienta salga de Zenya sintiéndose mejor de como llegó, con trabajo bien hecho y trato honesto.
        </p>
      </div>
      <div style={{ background: 'var(--lavender-50)', borderRadius: 'var(--radius-xl)', padding: 32 }}>
        <span style={{ ...eyebrow, color: 'var(--lavender-700)' }}>Visión</span>
        <p
          style={{
            fontFamily: 'var(--font-display)',
            fontSize: 24,
            lineHeight: 1.45,
            color: 'var(--ink-900)',
            margin: '14px 0 0',
          }}
        >
          Ser el lugar de referencia en Puebla cuando alguien busca cuidado personal hecho con calma y detalle.
        </p>
      </div>
    </section>
  </div>
);

export default About;
